module.exports = __webpack_public_path__ + "f6af0b04d7121f39f6a4a32a694dd823.png";